import { ContractNegotiation } from '@/modules/Customer/types'
import { ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import queryString from 'query-string'

export const getAllContractNegotiations = async (
    params: Record<string, any>
) => {
    const response = await datacentral.get<ResponseArray<ContractNegotiation>>(
        `/contracts/negotiations?${queryString.stringify(params)}`
    )
    return response.data
}

export const getContractNegotiationById = async (id: number) => {
    const response = await datacentral.get<ResponseObject<ContractNegotiation>>(
        `/contracts/negotiations/${id}`
    )
    return response.data
}
